import React, {useEffect, useState} from "react";
import {Button} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";

const SearchSubmit = props => {
  const [query, setQuery] = useState(queryStringToHash()); 

  useEffect(() => {
    const mutationObserver = new MutationObserver(_mutations => setQuery(queryStringToHash()));
    mutationObserver.observe(document, {childList: true, subtree: true});

    return () => mutationObserver.disconnect();
  }, []);

  return (
    <form method={props.method || 'POST'} action={props.action}>
      {Object.keys(query).map(key =>
        <input type="hidden" key={key} name={key} value={query[key]} />
      )}
      <Button type="submit" variant="primary" className="h-auto" size="sm">
        {props.label}
      </Button>
    </form>
  );
}

export default SearchSubmit;
